export default __webpack_public_path__ + "static/media/info.edfcaae8.svg";